// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2NorF","upload":"Small_upload__2n_BN","imageWrap":"Small_imageWrap__YEwa1","removeBtn":"Small_removeBtn__263A0"};